import { HeadingS, BodyM, HeadingLBold } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import CustomConfirmationDialog from 'components/CustomConfirmationDialog/CustomConfirmationDialog';
import React from 'react';
import { useSelector } from 'react-redux';
import { billValueSelector } from 'redux/modules/bills/selectors';

interface IPaymentRejectedDialogProps {
	isOpen: boolean;
	hideDialog: () => void;
}
const PaymentConfirmedDialog = ({ isOpen, hideDialog }: IPaymentRejectedDialogProps) => {
	const billsValue = useSelector(billValueSelector);

	return (
		<CustomConfirmationDialog
			isOpen={isOpen}
			hideDialog={hideDialog}
			header={
				<>
					<BodyM disableMargin>{translate('bills.payment.confirmed')}</BodyM>
					<BodyM disableMargin>{translate('thank.you')}</BodyM>
				</>
			}
		>
			<div>
				<HeadingLBold>
					<>
						{billsValue}
						{translate('OMR')}
					</>
				</HeadingLBold>
				<HeadingS color="success">{translate('payments.topup.paymentConfirmed')}</HeadingS>
			</div>
		</CustomConfirmationDialog>
	);
};

export default PaymentConfirmedDialog;
